import { QueryClient } from '@tanstack/react-query';

import { ApiError } from '@/shared/api/errors';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // 5min default keeps lookup data (categories, brands, currencies, payment
      // methods, etc.) hot across page navigations so the user does not see a
      // spinner every time they switch screens.
      staleTime: 5 * 60_000,
      gcTime: 30 * 60_000,
      refetchOnWindowFocus: false,
      refetchOnReconnect: 'always',
      retry: (count, err) => {
        const status = err instanceof ApiError ? err.status : 0;
        // retry 5xx once, never 4xx
        return status >= 500 && count < 1;
      },
    },
    mutations: {
      retry: false,
    },
  },
});
